<style lang="scss">
.nav-pill-left-bar {
  background: #fff;
  height: 100%;
}
.nav-pill-left-bar .nav-link {
  display: block;
  padding: 18px 15px;
  border-radius: 0;
  border-bottom: 1px solid #d3d6db;
  color: #6d6f7b;
  border-left: 5px solid transparent;
}
.nav-pill-left-bar.nav-pills .nav-link.active,
.nav-pill-left-bar.nav-pills .show > .nav-link {
  color: #1c1d26 !important;
  background-color: transparent;
  font-weight: 600 !important;
  border-left: 5px solid #19a883;
}
h1.page-head {
  font-size: 28px;
  margin-bottom: 12px;
}
.survey-form-wrapper {
  background: #fff;
  border-left: 1px solid #c8c8c8;
  height: 100%;
  position: relative;
  height: 600px;
}
.feedback-virtual-event {
  position: absolute;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  left: 0;
  top: 0;
  padding: 20px;
}
section.session-list-wrapper {
  margin-left: 40px;
}
.vue-form-generator .field-radios .radio-list label {
  display: inline-block;
  margin-right: 20px;
  float: left;
}
.form-group.valid.featured.field-checklist .wrapper {
  width: 100%;
  height: auto;
  overflow: visible;
  border: none;
}
.form-group.valid.featured.field-checklist .combobox.form-control {
  border: 0px;
}
.vue-form-generator .field-checklist .dropList,
.vue-form-generator .field-checklist .listbox {
  height: auto;
  max-height: none;
  overflow: auto;
}
.session-tab-wrapper input[type="text"] {
  height: 45px;
  font-size: 16px;
  color: #333;
  border: 1px solid #c8c8c8;
  padding: 0 15px;
  font-weight: 400;
  line-height: 18px;
  background: transparent;
}
button.savebutton {
  background: #19a883;
  border: none;
  padding: 9px 35px;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
}
</style>
<template>
  <div>
    <div id="divContainer" v-on:click="exitmenu">
      <!--<LeftMenu></LeftMenu>-->
      <!-- <TopMenu /> -->
      <section class="session-list-wrapper d-flex body-content SessionlistMultitracker">
        <div class="container">
          <h1 class="page-head text-uppercase">Survey</h1>
          <div>
            <div class="row no-gutters">
              <div class="col-5">
                <div
                  class="nav flex-column nav-pills nav-pill-left-bar"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <a
                    class="nav-link active"
                    id="aiLearning"
                    data-toggle="pill"
                    href="#v-pills-aiLearning"
                    role="tab"
                    aria-controls="v-pills-home"
                    aria-selected="true"
                  >AI Learning</a>
                  <a
                    class="nav-link"
                    id="art"
                    data-toggle="pill"
                    href="#v-pills-art"
                    role="tab"
                    aria-controls="v-pills-profile"
                    aria-selected="false"
                  >Art</a>
                  <a
                    class="nav-link"
                    id="virtualEvent"
                    data-toggle="pill"
                    href="#v-pills-virtualEvent"
                    role="tab"
                    aria-controls="v-pills-messages"
                    aria-selected="false"
                  >Feedback on Virtual Event</a>
                  <a
                    class="nav-link"
                    id="sessionExperience"
                    data-toggle="pill"
                    href="#v-pills-sessionExperience"
                    role="tab"
                    aria-controls="v-pills-settings"
                    aria-selected="false"
                  >Session Experience</a>
                  <a
                    class="nav-link"
                    id="sessionFeedback"
                    data-toggle="pill"
                    href="#v-pills-sessionFeedback"
                    role="tab"
                    aria-controls="v-pills-settings"
                    aria-selected="false"
                  >Session Experience</a>
                  <a
                    class="nav-link"
                    id="sessionFeedbackIntro"
                    data-toggle="pill"
                    href="#v-pills-sessionFeedbackIntro"
                    role="tab"
                    aria-controls="v-pills-settings"
                    aria-selected="false"
                  >Session feedback - Welcome/Intros</a>
                  <a
                    class="nav-link"
                    id="extend"
                    data-toggle="pill"
                    href="#v-pills-extend"
                    role="tab"
                    aria-controls="v-pills-settings"
                    aria-selected="false"
                  >To what extent do you agree or disagree regarding the event</a>
                  <a
                    class="nav-link"
                    id="virtualEvent2020"
                    data-toggle="pill"
                    href="#v-pills-virtualEvent2020"
                    role="tab"
                    aria-controls="v-pills-settings"
                    aria-selected="false"
                  >Virtual Event</a>
                </div>
              </div>
              <div class="col-7">
                <div class="tab-content survey-form-wrapper" id="v-pills-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="v-pills-aiLearning"
                    role="tabpanel"
                    aria-labelledby="aiLearning"
                  >AI Learning</div>
                  <div
                    class="tab-pane fade"
                    id="v-pills-art"
                    role="tabpanel"
                    aria-labelledby="art"
                  >Art</div>
                  <div
                    class="tab-pane fade"
                    id="v-pills-virtualEvent"
                    role="tabpanel"
                    aria-labelledby="virtualEvent"
                  >
                    <div class="feedback-virtual-event">
                      <div class="session-tab-wrapper">
                        <vue-form-generator :schema="schema" :model="model" :options="formOptions"></vue-form-generator>
                        <button v-on:click="saveFormData" class="savebutton">Submit</button>
                        <!--<input
                          type="submit"
                          v-on:click="saveFormData"
                          class="savebutton"
                          v-model="SubmitButtonText1"
                        />-->
                        <!--<a v-on:click="saveFormData" class="savebutton">{{ SubmitButtonText1 }}</a>-->
                        <div style="display:none;">
                          <pre>{{ model }}</pre>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="v-pills-sessionExperience"
                    role="tabpanel"
                    aria-labelledby="sessionExperience"
                  >!!!!!</div>
                  <div
                    class="tab-pane fade"
                    id="v-pills-sessionFeedback"
                    role="tabpanel"
                    aria-labelledby="sessionFeedback"
                  >uuuu</div>
                  <div
                    class="tab-pane fade"
                    id="v-pills-sessionFeedbackIntro"
                    role="tabpanel"
                    aria-labelledby="sessionFeedbackIntro"
                  >TTT</div>
                  <div
                    class="tab-pane fade"
                    id="v-pills-extend"
                    role="tabpanel"
                    aria-labelledby="extend"
                  >PPP</div>
                  <div
                    class="tab-pane fade"
                    id="v-pills-virtualEvent2020"
                    role="tabpanel"
                    aria-labelledby="virtualEvent2020"
                  >MMM</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
//import jQuery from "jquery";
//let $ = jQuery;
import Vue from "vue";
import VueFormGenerator from "vue-form-generator";
/*import LeftMenu from "../components/LeftMenu.vue";*/
import "vue-form-generator/dist/vfg.css";
//import TopMenu from "@/components/TopMenu.vue";
import db from "../components/firebaseInit";
import analytics from "@/components/Analytics";
import jQuery from "jquery";
let $ = jQuery;
Vue.use(VueFormGenerator);

//let json = [
//  {
//    fieldType: "TextInput",
//    isUnique: false,
//    isPlaceholderVisible: false,
//    placeholder: "Input your text here...",
//    label: "First Name",
//    isHelpBlockVisible: false,
//    helpBlockText: "Please input your helpblock here...",
//    isRequired: false
//  },
//  {
//    fieldType: "LongTextInput",
//    isUnique: false,
//    isPlaceholderVisible: false,
//    placeholder: "Input your text here...",
//    label: "Last Name",
//    isHelpBlockVisible: false,
//    helpBlockText: "Please input your helpblock here...",
//    isRequired: false
//  },
//  {
//    fieldType: "NumberInput",
//    isUnique: false,
//    label: "Age",
//    isHelpBlockVisible: false,
//    helpBlockText: "Please input your helpblock here...",
//    isRequired: false
//  },
//  {
//    fieldType: "SelectList",
//    isUnique: false,
//    label: "Building",
//    isHelpBlockVisible: false,
//    helpBlockText: "Please input your helpblock here...",
//    isRequired: false,
//    options: [
//      {
//        optionLabel: "Option 1",
//        optionValue: "Option 1"
//      },
//      {
//        optionLabel: "Option 2",
//        optionValue: "Option 2"
//      }
//    ]
//  },
//  {
//    fieldType: "RadioButton",
//    isUnique: false,
//    label: "Gender",
//    isHelpBlockVisible: false,
//    helpBlockText: "Please input your helpblock here...",
//    isRequired: false,
//    options: [
//      {
//        optionLabel: "Option 1",
//        optionValue: "Male"
//      },
//      {
//        optionLabel: "Option 2",
//        optionValue: "Female"
//      }
//    ]
//  },
//  {
//    fieldType: "Checkbox",
//    isUnique: false,
//    label: "Skills",
//    isHelpBlockVisible: false,
//    helpBlockText: "Please input your helpblock here...",
//    isRequired: false,
//    options: [
//      {
//        optionLabel: "Option 1",
//        optionValue: "Option 1"
//      },
//      {
//        optionLabel: "Option 2",
//        optionValue: "Option 2"
//      },
//      {
//        optionLabel: "Option 3",
//        optionValue: "Option 3"
//      }
//    ]
//  },

//  {
//    fieldType: "DatePicker",
//    isUnique: false,
//    label: "Date",
//    isHelpBlockVisible: false,
//    helpBlockText: "Please input your helpblock here...",
//    isRequired: false
//  },
//  {
//    fieldType: "TimePicker",
//    isUnique: false,
//    label: "Time",
//    isHelpBlockVisible: false,
//    helpBlockText: "Please input your helpblock here...",
//    isRequired: false
//  }
//];

let FormInputs = {};

var vm;
export default {
  components: {
    //LeftMenu
    //TopMenu
  },
  data() {
    return {
      model: FormInputs,

      schema: {
        fields: [],
      },

      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateBeforeSubmit: true,
      },
      eventcollection: this.$store.getters.getEventCollection,
      fields: [],
      fieldData: [],
      //FormId: "SF_TEST",
      FormId: "SurveyForm",
      FormJson: "",
      FormTitle: "",
      SubmitButtonText1: "",
    };
  },

  mounted() {
    debugger;
    $("#topmenu").show();
    if ($("#ulLeftMenu li").length > 0) {
      $("#leftMenuParent").show();
      $("#leftmenu").show();
    } else {
      $("#leftMenuParent").hide();
      $("#leftmenu").hide();
    }
    $("#btnAddUserView").click();
    vm = this;
    vm.scroll();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //-------------dynamic font selection --------------------------------------
    var urlpath = obj.EventFont[0].FontPath;
    var newStyle = document.createElement("style");
    newStyle.appendChild(
      document.createTextNode(
        "\
@font-face {\
    font-family: " +
          obj.EventFont[0].FontFamily +
          ";\
    src:" +
          urlpath +
          " ;\
}\
"
      )
    );

    document.head.appendChild(newStyle);

    $(
      "<style>* { font-family: '" +
        obj.EventFont[0].FontFamily +
        "' !important }</style>"
    ).appendTo("head");
    //-------------dynamic font selection --------------------------------------
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
    $("#divContainer").css(
      "background-image",
      "url(" + obj.EventBranding[0].eventBGImage + ")"
    );

    vm.eventcollection = vm.$store.getters.getEventCollection;
    //vm.FormId = "SF_TEST"; // "SF1593633081332";
    var docRef = db
      .collection(vm.eventcollection)
      .doc("FormList")
      .collection("Forms")
      .doc(vm.FormId);
    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          debugger;
          vm.FormTitle = doc.data().FormTitle;
          //alert(vm.SubmitButtonText1);
          vm.FormJson = doc.data().FormJson;
          vm.fields = doc.data().FormJson;
          //console.log(vm.SubmitButtonText1);
          console.log(JSON.stringify(vm.fields));
          vm.FormJson.map((x) => {
            FormInputs[x.cid.split(" ").join("").toLowerCase()] = "";
          });
          vm.SubmitButtonText1 = doc.data().SubmitButtonText;
          //FormInputs = {};
          //vm.fields.map(x => {
          //  vm.fieldData[
          //    x.label
          //      .split(" ")
          //      .join("")
          //      .toLowerCase()
          //  ] = "";
          //});
          let arr = [];
          vm.fields.map((x) => {
            if (x.field_type == "text") {
              let obj = {};
              obj["id"] = x.cid;
              obj["type"] = "input";
              obj["inputType"] = "text";
              obj["label"] = x.label;
              obj["model"] = x.cid.split(" ").join("").toLowerCase();
              obj["required"] = x.required;
              obj["readonly"] = false;
              obj["featured"] = true;
              obj["disabled"] = false;
              obj["placeholder"] = x.label;
              obj["description"] = x.field_options.description;
              obj["validator"] = VueFormGenerator.validators.string;

              arr.push(obj);
            }

            if (x.field_type == "email") {
              let obj = {};
              obj["id"] = x.cid;
              obj["type"] = "input";
              obj["inputType"] = "email";
              obj["label"] = x.label;
              obj["model"] = x.cid.split(" ").join("").toLowerCase();
              obj["required"] = x.required;
              obj["readonly"] = false;
              obj["featured"] = true;
              obj["disabled"] = false;
              obj["placeholder"] = x.label;
              obj["description"] = x.field_options.description;
              obj["validator"] = VueFormGenerator.validators.email;

              arr.push(obj);
            }

            //if (x.field_type == "NumberInput") {
            //  let obj = {};
            //  obj["type"] = "input";
            //  obj["inputType"] = "number";
            //  obj["label"] = x.label;
            //  obj["model"] = x.label
            //    .split(" ")
            //    .join("")
            //    .toLowerCase();
            //  obj["required"] = x.isRequired;
            //  obj["readonly"] = false;
            //  obj["featured"] = true;
            //  obj["disabled"] = false;
            //  obj["placeholder"] = "";
            //  obj["min"] = 0;
            //  obj["validator"] = VueFormGenerator.validators.number;

            //  arr.push(obj);
            //}

            if (x.field_type == "paragraph") {
              let obj = {};
              obj["id"] = x.cid;
              //obj["type"] = "textarea";
              //obj["inputType"] = "text";
              //obj["type"] = "textarea";
              //obj["inputType"] = "textarea";
              obj["label"] = x.label;
              obj["model"] = x.cid.split(" ").join("").toLowerCase();
              obj["required"] = x.isRequired;
              obj["readonly"] = false;
              obj["featured"] = true;
              obj["disabled"] = false;
              obj["placeholder"] = x.label;
              obj["description"] = x.field_options.description;
              obj["min"] = 0;
              obj["validator"] = VueFormGenerator.validators.number;

              arr.push(obj);
            }

            if (x.field_type == "dropdown") {
              let obj = {},
                sel = { hideNoneSelectedText: true };
              obj["id"] = x.cid;
              obj["type"] = "select";
              obj["inputType"] = "text";
              obj["label"] = x.label;
              obj["model"] = x.cid.split(" ").join("").toLowerCase();
              obj["required"] = x.required;
              obj["readonly"] = false;
              obj["featured"] = true;
              obj["disabled"] = false;
              obj["placeholder"] = x.label;
              obj["description"] = x.field_options.description;
              //debugger;
              obj["selectOptions"] = sel;
              let list = [];
              x.field_options.options.map((y) => {
                list.push(y.label);
              });
              obj["values"] = list;
              arr.push(obj);
            }

            if (x.field_type == "radio") {
              let obj = {},
                sel = { hideNoneSelectedText: true };
              obj["id"] = x.cid;
              obj["type"] = "radios";
              obj["label"] = x.label;
              obj["model"] = x.cid.split(" ").join("").toLowerCase();
              obj["required"] = x.isRequired;
              obj["readonly"] = false;
              obj["featured"] = true;
              obj["disabled"] = false;
              obj["placeholder"] = "";
              obj["selectOptions"] = sel;
              let list = [];

              //    options: [
              //      {
              //        optionLabel: "Option 1",
              //        optionValue: "Male"
              //      },
              //      {
              //        optionLabel: "Option 2",
              //        optionValue: "Female"
              //      }
              //    ]

              x.field_options.options.map((y) => {
                var item = {}; //y;
                item.optionLabel = y.label;
                item.optionValue = y.label;
                //item.class = "option-item";
                //debugger;
                //list.push(item);
                list.push(y.label);
              });
              //obj["options"] = list;
              obj["values"] = list;
              arr.push(obj);
            }

            if (x.field_type == "checkboxes") {
              let obj = {},
                sel = { hideNoneSelectedText: true };
              obj["id"] = x.cid;
              obj["type"] = "checklist";
              obj["label"] = x.label;
              obj["model"] = x.cid.split(" ").join("").toLowerCase();
              obj["required"] = x.isRequired;
              obj["readonly"] = false;
              obj["featured"] = true;
              obj["disabled"] = false;
              obj["placeholder"] = "";
              obj["selectOptions"] = sel;
              let list = [];
              x.field_options.options.map((y) => {
                list.push(y.label);
              });
              obj["values"] = list;
              obj["multi"] = true;
              obj["multiSelect"] = true;
              arr.push(obj);
            }

            //if (x.field_type == "DatePicker") {
            //  let obj = {};
            //  obj["type"] = "input";
            //  obj["inputType"] = "date";
            //  obj["label"] = x.label;
            //  obj["model"] = x.label
            //    .split(" ")
            //    .join("")
            //    .toLowerCase();
            //  obj["required"] = x.isRequired;
            //  obj["readonly"] = false;
            //  obj["featured"] = true;
            //  obj["disabled"] = false;
            //  arr.push(obj);
            //}

            //if (x.field_type == "TimePicker") {
            //  let obj = {};
            //  obj["type"] = "input";
            //  obj["inputType"] = "time";
            //  obj["label"] = x.label;
            //  obj["model"] = x.label
            //    .split(" ")
            //    .join("")
            //    .toLowerCase();
            //  obj["required"] = x.isRequired;
            //  obj["readonly"] = false;
            //  obj["featured"] = true;
            //  obj["disabled"] = false;

            //  arr.push(obj);
            //}
          });
          vm.schema.fields = arr;
        }
      })
      .catch(function (error) {
        console.log("Error fetching Survey Form:", error);
      });
  },
  methods: {
    onValidated: function (isValid, errors) {
      console.log("Validation result: ", isValid, ", Errors:", errors);
    },
    saveFormData: function () {
      //console.log("event ->", event);
      console.log("save form ->", vm.model);

      var submitId = new Date().getTime().toString();

      var docRef = db
        .collection(vm.eventcollection)
        .doc("FormList")
        .collection("Forms")
        .doc(vm.FormId)
        .collection("FormSubmissions")
        .doc(submitId);
      docRef
        .get()
        .then(function () {
          var docObj = new Object();
          debugger;
          docObj.FormId = vm.FormId;
          //docObj.FormTitle = vm.FormTitle;
          //docObj.FormJson = vm.FormJson;
          //var m = vm.model;
          //var getKeys = [];
          //var keys = [];
          //for (var key1 in vm.model) {
          //  keys.push(key1);
          //}
          //getKeys.push(keys);

          //console.log(getKeys);

          var allInputs = {};
          //var allKeys = Object.keys(vm.model);
          for (var key in vm.model) {
            //var keys = Object();
            if (vm.model[key] != undefined && vm.model[key] != "") {
              var input = {};
              var field = vm.fields.filter(function (value) {
                return value.cid == key;
              });
              debugger;
              if (field.length > 0) {
                input.label = field[0].label;
                input.des = field[0].field_options.description;
              }
              input.value = vm.model[key];
              allInputs[key] = input;
            }
            //vm.model[allKeys[12]]
            //allInputs.push(keys);
          }
          docObj.FormInputs = allInputs;
          docObj.CreatedDate = new Date();

          db.collection(vm.eventcollection)
            .doc("FormList")
            .collection("Forms")
            .doc(vm.FormId)
            .collection("FormSubmissions")
            .doc(submitId)
            .set(docObj)
            .then(function () {
              console.log("sucess");
            })
            .catch(function (error) {
              console.error("Error creating SurveyForm: ", error);
            });
        })
        .catch(function (error) {
          console.log("Error saving Survey Form:", error);
        });
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    scroll: function () {
      window.onscroll = () => {
        //alert("scroll");
        if (!self.IsSearchMode) {
          let bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight + 1 >=
            document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            //this.AddAnalitics(event, "scroll");
          }
        }
      };
    },
  },
};
</script>
